<template>
  <div ref="top-ads" class="top-ads ad-slot">
    <div class="ad_container">
      <div class="ad_wrapper">
        <!-- <div id="div-gpt-ad-1585758066805-0" v-if="screen.isDesktop"></div>
        <div id="div-gpt-ad-1556531810809-0" v-else></div> -->

        <div v-if="screen.isDesktop" id="div-gpt-ad-1585758066805-0"></div>
        <div v-else id="div-gpt-ad-1585749611991-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-ads',
  computed: {
    screen() {
      return this.$store.state.screen;
    },
  },
  mounted() {
    if (document.readyState == 'complete') {
      this.loadAds();
    } else {
      document.addEventListener(
        'scriptReady',
        (e) => {
          this.loadAds();
        },
        true
      );
    }
  },
  methods: {
    loadAds() {
      const el = this;
      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            const id = event.slot.getSlotElementId();
            if (id) {
              if (el.$refs['top-ads'] && el.$refs['top-ads'].classList.contains('ad-slot')) {
                el.$refs['top-ads'].style.display = 'none';
                return;
              }
            }
          } else {
            const id = event.slot.getSlotElementId();
            if (id) {
              if (el.$refs['top-ads'] && el.$refs['top-ads'].classList.contains('ad-slot')) {
                el.$refs['top-ads'].style.display = 'block';
                return;
              }
            }
          }
        });
        googletag.pubads().removeEventListener('slotRenderEnded');

        if (this.$store.state.screen.isDesktop) {
          googletag
            .defineSlot('/187290464/Revamp-Desktop-TopbannerNew1', [970, 250], 'div-gpt-ad-1585758066805-0')
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display('div-gpt-ad-1585758066805-0');
        }
        if (!this.$store.state.screen.isDesktop) {
          googletag
            .defineSlot('/187290464/Revamp_Mobile_TopBannernew', [320, 100], 'div-gpt-ad-1585749611991-0')
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display('div-gpt-ad-1585749611991-0');
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ad_container {
  text-align: center;
}

.ad_wrapper {
  display: inline-block;
  position: relative;
}

.top-ads {
  display: none;
  margin: 30px 0;
}

@media (max-width: 991px) {
  .top-ads {
    margin: 30px 0 16px;
  }
}
</style>
